// responsible for enabling the  grey background when the user waits for the image processing
$(document).ready(function() {
    $('#fileInput').on('change', function() {
        $('#overlay').css("display", "block");
    });
});
